export { ConfirmEmail, WaitForApproval } from './Step2Pages';
